import { getValue } from "./GetValue";

/**
 * Converts a value to its annual equivalent based on the provided unit.
 *
 * @param {Object} params - The parameters object.
 * @param {number|string} params.value - The value to be annualised. Can be a number or a string representation of a number.
 * @param {string} params.unit - The unit of the value. If "Monthly", the value is multiplied by 12; otherwise, returned as is.
 * @returns {number} The annualised value.
 */
export const annualise = ({ value, unit }) => {
  const val = getValue(value);
  return unit === "Monthly" ? val * 12 : val;
};
